import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.some.js";
import { List as ImmutableList, Record as ImmutableRecord } from 'immutable';
import { MODAL_OPEN, MODAL_CLOSE } from '../actions/modals';
const ModalRecord = ImmutableRecord({
  modalType: '',
  modalProps: null
});
export default function modal(state = ImmutableList(), action) {
  switch (action.type) {
    case MODAL_OPEN:
      return state.push(ModalRecord({
        modalType: action.modalType,
        modalProps: action.modalProps
      }));
    case MODAL_CLOSE:
      if (state.size === 0) {
        return state;
      }
      if (action.modalType === undefined) {
        return state.pop();
      }
      if (state.some(({
        modalType
      }) => action.modalType === modalType)) {
        return state.slice(0, state.findLastIndex(({
          modalType
        }) => action.modalType === modalType));
      }
      return state;
    default:
      return state;
  }
}